import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
import { usePreferencesStore } from "@/stores/usePreferencesStore";

export const PreferenceEffects = () => {
  const language = usePreferencesStore((state) => state.language);
  const { t } = useTranslation("common");

  useEffect(() => {
    void i18n.changeLanguage(language);
    document.documentElement.lang = language;
  }, [language]);

  // El título de la pestaña vive aquí y no en `index.html`: el slogan es texto traducible y
  // tiene que seguir al idioma que elige el usuario. Este es el único sitio que escribe
  // `document.title`. Una página no puede reclamarlo desde su propio efecto: React corre los
  // efectos de hijo a padre, así que este, montado por encima del router, corre el último y
  // pisaría el título de la página en cada cambio de idioma.
  useEffect(() => {
    document.title = t("common.meta.title");
  }, [t, language]);

  return null;
};
